import { handleWindow } from '@/utils';

const win = handleWindow();

const ua = win.navigator.userAgent.toLowerCase();

export const IS_WECHAT = /micromessenger/i.test(ua);

export const IS_IOS = /(iphone|ipad|ipod|ios)/i.test(ua);

export const IS_ANDROID = /android|adr/gi.test(ua);

export const IS_DJI_APP = /DJI-App-/i.test(ua);

export const IS_DJI_FLY = /djifly/i.test(ua);

export const IS_DJI_STORE = /DJI-App-(Ios|Android)/i.test(ua);

export const IS_DJI_MIMO = /DJI-App-mimo-(Ios|Android)/i.test(ua);

export const IS_DJI_MIMO_IOS = /DJI-App-mimo-ios/i.test(ua);

export const extraUA = ['pilot', 'dji-app-android', 'dji-app-ios', 'dji-app-android', 'djifly_ios', 'dididayao', 'dji-app-mimo-ios', 'dji-app-mimo-android'];

export const MAX_RELATED_DEVICES = 5;

export const MAX_TITLE_LENGTH = 30;

export const MAX_DESC_LENGTH = 200 * 1000;

export const STORE_APP_BANNER_ENTRY = '2';

export const MIMO_APP_LIST_ENTRY = '3';

export enum PromiseState {
  PENDING = "pending",
  FULFILLED = "fulfilled",
  REJECTED = "rejected"
};

/** 资源位管理枚举 */
export enum SourceType {
  /** banner */
  Banner = 'banner',
  /** 贴片广告 */
  PreRolls = 'pre_rolls',
  /** 快捷入口 */
  QuickImport = 'quick_import',
  /** 推荐帖子 */
  RecommendThreads = 'recommend_threads',
  /** 圈子推荐 */
  RecommendCircles = 'recommend_circles',
}

/** 外链打开方式 */
export enum OpenType {
  /** 新窗口打开 */
  NewWindow = 1,
  /** 当前窗口打开 */
  CurrentWindow = 2,
}
